var map = {
	"./Indian_Institute_of_Technology_Bombay_Logo.svg.png": 161,
	"./animated_ashutosh.png": 162,
	"./animated_logo.svg": 163,
	"./blockchain.svg": 164,
	"./blogs_image.svg": 165,
	"./codeInLogo.png": 166,
	"./contactMail.png": 167,
	"./coursera_logo.png": 168,
	"./cropped_Rupesh.png": 169,
	"./data_science.svg": 170,
	"./deeplearning_ai_logo.png": 171,
	"./delhivery_logo.png": 172,
	"./developerActivity.svg": 173,
	"./dsc_logo.png": 174,
	"./education.svg": 175,
	"./experience.svg": 176,
	"./feelingProud.svg": 177,
	"./freecopy_logo.png": 178,
	"./fullstack.svg": 179,
	"./gcp_logo.png": 180,
	"./github_logo.png": 181,
	"./googleAssistant.jpg": 182,
	"./googleAssistant.svg": 183,
	"./google_logo.png": 184,
	"./hs.png": 185,
	"./ibm_logo.png": 186,
	"./ieeenitp.png": 187,
	"./iiitk_logo.png": 188,
	"./ind_rail.png": 189,
	"./intel_logo.jpg": 190,
	"./jsFramework.svg": 191,
	"./legato_logo.png": 192,
	"./manOnTable.svg": 193,
	"./microsoft_logo.png": 194,
	"./mozilla_logo.png": 195,
	"./muffito_logo.png": 196,
	"./nextuLogo.jpg": 197,
	"./nitp-modified.png": 198,
	"./nitp.png": 199,
	"./nptel_logo.png": 200,
	"./nss.jpeg": 201,
	"./portfolio.gif": 202,
	"./programmer.svg": 203,
	"./projects_image.svg": 204,
	"./pwa.png": 205,
	"./robo.png": 206,
	"./saayaHealthLogo.png": 207,
	"./sparkAR.png": 208,
	"./stanford_logo.png": 209,
	"./talksCardBack.svg": 210,
	"./talksCardBackAlt.svg": 211,
	"./tedxnitp.png": 212,
	"./ui_ux_design.svg": 213,
	"./vit.png": 214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;